import React, { useEffect, useState } from "react";
import useApi from "../../CustomHooks/useApi";
import { gearViewAPI } from "../../../api/apiClient";
import Loading from "../../../Loading";
import "../../../css/Views/GearView.css";

const typeLabel = (t) => {
  switch (t) {
    case "Transfer": return "Przekazanie";
    case "Update": return "Aktualizacja";
    default: return t;
  }
};

const HistoryModal = ({ isOpen, onClose }) => {
  const { callApi, isLoading } = useApi();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (!isOpen) return;
    callApi(() => gearViewAPI.getMyHistory({ take: 200 }), (data) => setRows(data ?? []));
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="modal-backdrop">
      <div className="modal-card history-modal">
        <div className="modal-header">
          <div className="modal-title">Historia moich zasobów</div>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        
        {isLoading ?  <Loading isLoading={true} /> : 
        <div className="history-list">
          {rows.length === 0 && !isLoading && <div className="muted">Brak wpisów.</div>}
          {rows.map((r, idx) => (
            <div key={idx} className="history-row">
              <div className="history-meta">
                <span className="history-date">
                  {new Date(r.createdAt).toLocaleString()}
                </span>
              </div>
              <div className="history-note">{r.note}</div>
            </div>
          ))}
        </div>
        }
      </div>
    </div>
  );
};

export default HistoryModal;
